import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const NewsDetailPage = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const token = localStorage.getItem("admin_jwt");

  useEffect(() => {
    if (!id) return;
    // /api/admin/news?id=xxxx に統一（method: GET）
    fetch(`/api/admin/news?id=${encodeURIComponent(id)}`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error("取得失敗");
        return res.json();
      })
      .then(setItem)
      .catch(() => setItem(null));
  }, [id, token]);

  if (!item) return <p className="text-gray-500">読み込み中...</p>;

  return (
    <div className="adm-card max-w-3xl mx-auto">
      <p className="text-sm text-gray-500">
        {item.createdAt
          ? new Date(item.createdAt).toLocaleDateString("ja-JP", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          : ""}
      </p>
      <h2 className="text-2xl font-bold my-2 text-gray-800">{item.title}</h2>
      <p className="mb-4 whitespace-pre-wrap text-gray-700">{item.body}</p>
      {item.image && (
        <img src={item.image} alt="" className="mb-4 rounded max-h-80 object-contain" />
      )}
      <div className="flex items-center gap-2 pt-4 border-t border-gray-100">
        <Link to={`/admin/news/${id}/edit`} className="adm-btn-warn">
          編集
        </Link>
        <Link to="/admin/news" className="adm-btn-sub ml-auto">
          ← 一覧に戻る
        </Link>
      </div>
    </div>
  );
};

export default NewsDetailPage;
